/*** IMPORTS FROM imports-loader ***/
import Translator from "bazinga-translator";

(function (t) {
// ro
t.add("cart.tickets.no_available_tickets_for_seating", "Nu exist\u0103 bilete disponibile pentru locurile selectate", "PayseraCartBundle", "ro");
t.add("cart.tickets.no_available_tickets", "Nu exist\u0103 bilete disponibile", "PayseraCartBundle", "ro");
t.add("paysera_cart.discount.invalid_code", "Cod de reducere nevalid", "PayseraCartBundle", "ro");
})(Translator);
